import cx from 'classnames';
import React from 'react';
import styles from './Heading.module.scss';
export const Heading = ({ children, level = 1, scale, className = '', isFancyFont, pullUp, defaultColors = true, defaultStyles = true, }) => {
    const Tag = ((level <= 6 && `h${level}`) || `strong`);
    const defaultStyleClasses = defaultStyles
        ? {
            [styles[`scale${scale}`]]: scale,
            [styles.hBlock]: level === 7,
            [styles.hZooja]: isFancyFont,
            [styles.pullUp]: pullUp,
            [styles.colourDarkBlue]: !!defaultColors,
        }
        : {};
    const tagClassname = cx(styles.h, defaultStyleClasses, className);
    const tagProps = Object.assign({ className: tagClassname }, (Tag === 'strong' ? { role: 'heading' } : {}));
    return <Tag {...tagProps}>{children}</Tag>;
};
